
    <div *ngIf="_selected"><ng-content></ng-content></div>
  